"use client"

import { useState, useEffect } from "react"
import "../css/DistributorsSection.css"
import imgc from "../img/imgc.png"
import img1 from "../img/slide/1.png"
import img2 from "../img/slide/2.png"
import img3 from "../img/slide/3.png"
import img4 from "../img/slide/4.png"
import img5 from "../img/slide/5.png"
import img6 from "../img/slide/6.png"
import img7 from "../img/slide/7.png"
import img8 from "../img/slide/8.png"
import img9 from "../img/slide/9.png"
import img10 from "../img/slide/10.png"
import img11 from "../img/slide/11.png"
import img12 from "../img/slide/12.png"
import img13 from "../img/slide/13.png"
import img14 from "../img/slide/14.png"
import img15 from "../img/slide/15.png"

function DistributorsSection() {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [itemsPerView, setItemsPerView] = useState(6)

  const brandImages = [
    img1, img2, img3, img4, img5, img6, img7,
    img8, img9, img10, img11, img12, img13, img14, img15
  ]

  const totalImages = brandImages.length

  // Ajustar items por vista segun el ancho de pantalla
  useEffect(() => {
    const updateItemsPerView = () => {
      if (window.innerWidth < 480) {
        setItemsPerView(2)
      } else if (window.innerWidth < 768) {
        setItemsPerView(3)
      } else {
        setItemsPerView(6)
      }
    }

    updateItemsPerView()
    window.addEventListener("resize", updateItemsPerView)
    return () => window.removeEventListener("resize", updateItemsPerView)
  }, [])

  const nextSlide = () => {
    setCurrentIndex((prev) => {
      const maxIndex = totalImages - itemsPerView
      return prev >= maxIndex ? 0 : prev + 1
    })
  }

  const prevSlide = () => {
    setCurrentIndex((prev) => {
      const maxIndex = totalImages - itemsPerView
      return prev === 0 ? maxIndex : prev - 1
    })
  }

  const transformValue = `translateX(-${currentIndex * (100 / itemsPerView)}%)`

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide()
    }, 2000)
    return () => clearInterval(interval)
  }, [itemsPerView])

  return (
    <section className="distributors-section">
      <div className="distributors-container">
        <div className="ic-logo">
          <img src={imgc || "/placeholder.svg"} alt="IC Logo" />
        </div>

        <h2 className="distributors-title">Somos distribuidores autorizados</h2>

        <div className="brands-carousel">
          <button className="carousel-arrow carousel-arrow-left" onClick={prevSlide}>
            &#8249;
          </button>

          <div className="brands-container">
            <div className="brands-track" style={{ transform: transformValue }}>
              {brandImages.map((brand, index) => (
                <div key={index} className="brand-item">
                  <img src={brand || "/placeholder.svg"} alt={"Brand " + (index + 1)} />
                </div>
              ))}
            </div>
          </div>

          <button className="carousel-arrow carousel-arrow-right" onClick={nextSlide}>
            &#8250;
          </button>
        </div>
      </div>
    </section>
  )
}

export default DistributorsSection
